import fetcher from 'api/fetcher';

import urlParser from 'bloko/common/urlParser';

import { setFilteredTranslations, setLoadFilteredTranslations } from 'store/models/translations';

export default () => {
    return (dispatch, getState) => {
        const { filterType, filterValue } = getState().translations;
        dispatch(setLoadFilteredTranslations(true));
        const queryStr = urlParser.stringify({ [filterType]: filterValue });
        return fetcher
            .get(`/api/v1/admin/translations/by_filter?${queryStr}`)
            .then((data) => {
                dispatch([setFilteredTranslations(data), setLoadFilteredTranslations(false)]);
            })
            .catch(() => {
                dispatch([setFilteredTranslations([]), setLoadFilteredTranslations(false)]);
            });
    };
};
